import { Injectable } from '@angular/core';
import { BackendService } from './backend.service';
import { environment } from '../../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { head } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ShopService {
  baseURL = `${environment.baseUrl}/`;

  constructor(private backendService: BackendService) {}

  getAllProducts(): any {
    const url = `${this.baseURL}shopify/all/`;
    return this.backendService.get(url).pipe(
      map((shopifyData) => {
        const { products = [] } = shopifyData;
        const items = products.map((item) => {
          // @ts-ignore
          const avatarURL = head(item.images)?.src;
          // @ts-ignore
          const itemPrice = head(item.variants)?.price;
          const url = `https://livingmeaningfully.myshopify.com/products/${this.slugify(item.title)}`;

          return { ...item, avatarURL, itemPrice, url };
        });
        return {
          items,
        };
      }),
      catchError((errorRes) => throwError(errorRes)),
    );
  }

  slugify(text) {
    return text
      .toLowerCase() // Convert to lowercase
      .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric characters except spaces and hyphens
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Collapse multiple hyphens into a single hyphen
      .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
  }
}
